import { render, staticRenderFns } from "./Franquicia.vue?vue&type=template&id=01bb4b6c"
import script from "./Franquicia.vue?vue&type=script&lang=js"
export * from "./Franquicia.vue?vue&type=script&lang=js"
import style0 from "./Franquicia.vue?vue&type=style&index=0&id=01bb4b6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports